<template>
    <div class="block" :class="{'deactive': !active}" @click="$emit('click')">
        <div class="block--circle" :class="[{'is-selected': selectedReseller}, {'deactive': !active}]">
            <img v-if="logo !== '' && logo !== null" class="img-circle" :src="logo">
        </div>

        <p>{{ reseller }}</p>
        <p>{{ t('general.clients') }}: {{ clientsCount }}</p>

        <div class="block--options" v-if="options">
            <i v-if="id !== 2 && !active" class="fal fa-user-check" @click="$emit('activateReseller')" v-tooltip.bottom="$translate.text('tooltip.activate')"></i>
            <i v-if="id !== 2 && active" class="fal fa-user-check" @click="$emit('deactivateReseller')" v-tooltip.bottom="$translate.text('tooltip.deactivate')"></i>
            <i v-if="id !== 2" class="fal fa-trash-alt" @click="$emit('deleteReseller')" v-tooltip.bottom="$translate.text('tooltip.delete')"></i>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ResellerBlock',

    props: {
        id: {
            type: Number,
            required: true,
        },

        reseller: {
            type: String,
            default: null,
        },

        clientsCount: {
            type: Number,
            required: true,
        },

        isPending: {
            type: Boolean,
            default: false,
        },

        selectedReseller: {
            type: Boolean,
            default: false,
        },

        options: {
            type: Boolean,
            default: false,
        },
        logo: {
            type: String,
            default: '',
        },

        active: {
            type: Boolean,
        },
    },
};
</script>
<style lang="scss" scoped>
.block.deactive {
    background-color: rgba(255,255,255, 0.5);
}
.block {
    background-color: white;
    border-radius: 5px;
    padding: 70px 10px 10px 10px;
    text-align: center;
    position: relative;

    p:first-child {
        margin-bottom: 10px;
    }

    &--circle {
        position: absolute;
        left: calc(50% - 55px);
        top: -45px;
        border: 5px solid #F0F0F0;
        width: 100px;
        height: 100px;
        background-color: $yellow;
        border-radius: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: 300ms all;

        &.is-selected {
            background-color: #f9e33d;
        }

        &.deactive {
            background: rgba(254,203,27, 0.5);
        }

        i {
            font-size: 48px;
            color: $black;
        }
    }

    &--options {
        margin-top: 30px;
        margin-bottom: 20px;

        i {
            font-size: 20px;
            color: $blue-darker;
            cursor: pointer;
        }
    }

    .fal + .fal {
        margin-left: 8px;
    }
}

.img-circle {
    position: absolute;
    border: 5px solid #F0F0F0;
    width: 100px;
    height: 100px;
    background-color: $yellow;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 300ms all;
    object-fit: contain;
}
</style>
